<template>
  <!--  <el-dialog :visible="visible" @close="$emit('close')" >-->
  <!--  </el-dialog>-->
</template>

<script>
import { MessageBox } from 'dygc-ui'

export default {
  name: 'ErrorMessageBox',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  created() {
    MessageBox.alert(this.data.message || '')
  }
  // data() {
  //   return {
  //     visible: false
  //   }
  // },
  // mounted() {
  //   this.visible = true
  // }
}
</script>

<style scoped>

</style>